import { LinearProgress } from "@mui/material";

const LoadingSuspense = () => {
  return <LinearProgress sx={{ position: "absolute", width: "calc(100vw)", zIndex: 1250 }} />;
};

export default LoadingSuspense;
